import { CountryType } from "$/utils/types/misc.types";

export const COUNTRIES = [
  "Afghanistan",
  "Albanie",
  "Algérie",
  "Angola",
  "Argentine",
  "Arménie",
  "Aruba",
  "Australie",
  "Autriche",
  "Azerbaïdjan",
  "Bahamas",
  "Bahreïn",
  "Bangladesh",
  "Barbade",
  "Biélorussie",
  "Belgique",
  "Belize",
  "Bolivie",
  "Bosnie-Herzégovine",
  "Botswana",
  "Brésil",
  "Brunéi",
  "Bulgarie",
  "Cambodge",
  "Cameroun",
  "Canada",
  "Îles Caïmans",
  "Chili",
  "Chine",
  "Colombie",
  "Congo",
  "Costa Rica",
  "Croatie",
  "Cuba",
  "Chypre",
  "République tchèque",
  "Danemark",
  "République dominicaine",
  "Équateur",
  "Égypte",
  "Salvador",
  "Estonie",
  "Îles Féroé",
  "Finlande",
  "France",
  "Polynésie française",
  "Gabon",
  "Géorgie",
  "Allemagne",
  "Ghana",
  "Grèce",
  "Groenland",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guinée",
  "Haïti",
  "Royaume hachémite de Jordanie",
  "Honduras",
  "Hong Kong",
  "Hongrie",
  "Islande",
  "Inde",
  "Indonésie",
  "Iran",
  "Irak",
  "Irlande",
  "Île de Man",
  "Israël",
  "Italie",
  "Jamaïque",
  "Japon",
  "Kazakhstan",
  "Kenya",
  "Kosovo",
  "Koweït",
  "Lettonie",
  "Liban",
  "Libye",
  "Liechtenstein",
  "Luxembourg",
  "Macédoine",
  "Madagascar",
  "Malaisie",
  "Malte",
  "Martinique",
  "Maurice",
  "Mayotte",
  "Mexique",
  "Mongolie",
  "Monténégro",
  "Maroc",
  "Mozambique",
  "Myanmar [Birmanie]",
  "Namibie",
  "Népal",
  "Pays-Bas",
  "Nouvelle-Calédonie",
  "Nouvelle-Zélande",
  "Nicaragua",
  "Nigéria",
  "Norvège",
  "Oman",
  "Pakistan",
  "Palestine",
  "Panama",
  "Papouasie-Nouvelle-Guinée",
  "Paraguay",
  "Pérou",
  "Philippines",
  "Pologne",
  "Portugal",
  "Porto Rico",
  "République de Corée",
  "République de Lituanie",
  "République de Moldavie",
  "Roumanie",
  "Russie",
  "Sainte-Lucie",
  "Saint-Marin",
  "Arabie Saoudite",
  "Sénégal",
  "Serbie",
  "Singapour",
  "Slovaquie",
  "Slovénie",
  "Afrique du Sud",
  "Espagne",
  "Sri Lanka",
  "Soudan",
  "Suriname",
  "Swaziland",
  "Suède",
  "Suisse",
  "Taïwan",
  "Tanzanie",
  "Thaïlande",
  "Trinité-et-Tobago",
  "Tunisie",
  "Turquie",
  "Îles Vierges des États-Unis",
  "Ukraine",
  "Émirats Arabes Unis",
  "Royaume-Uni",
  "États-Unis",
  "Uruguay",
  "Venezuela",
  "Vietnam",
  "Zambie",
  "Zimbabwe",
];

export const COUNTRIES_AND_CITIES: Record<CountryType, string[]> = {
  Afghanistan: [
    "Herat",
    "Kabul",
    "Kandahar",
    "Molah",
    "Rana",
    "Shar",
    "Sharif",
    "Wazir Akbar Khan",
    "Mazar-i-Sharif",
    "Jalalabad",
  ],
  Albanie: [
    "Tirana",
    "Durrës",
    "Vlorë",
    "Shkodër",
    "Fier",
    "Elbasan",
    "Berat",
    "Korçë",
  ],
  Algérie: [
    "Alger",
    "Oran",
    "Constantine",
    "Annaba",
    "Blida",
    "Batna",
    "Tizi Ouzou",
    "Sétif",
  ],
  Angola: [
    "Luanda",
    "Lubango",
    "Benguela",
    "Lobito",
    "Kuito",
    "Huambo",
    "Malanje",
    "Namibe",
  ],
  Argentine: [
    "Buenos Aires",
    "Córdoba",
    "Rosario",
    "Mendoza",
    "La Plata",
    "Tucumán",
    "Mar del Plata",
    "Salta",
  ],
  Arménie: [
    "Yerevan",
    "Gyumri",
    "Vanadzor",
    "Vagharshapat",
    "Vardenis",
    "Kapan",
    "Hrazdan",
  ],
  Aruba: ["Oranjestad", "San Nicolas", "Noord", "Santa Cruz"],
  Australie: [
    "Sydney",
    "Melbourne",
    "Brisbane",
    "Perth",
    "Adélaïde",
    "Canberra",
    "Gold Coast",
    "Newcastle",
  ],
  Autriche: [
    "Vienne",
    "Salzbourg",
    "Innsbruck",
    "Graz",
    "Linz",
    "Klagenfurt",
    "Bregenz",
    "Eisenstadt",
  ],
  Azerbaïdjan: [
    "Bakou",
    "Gandja",
    "Mingäçevir",
    "Sumqayit",
    "Mingachevir",
    "Nakhchivan",
    "Shaki",
  ],
  Bahamas: [
    "Nassau",
    "Freeport",
    "West End",
    "Marsh Harbour",
    "Lucaya",
    "Governor's Harbour",
  ],
  Bahreïn: ["Manama", "Riffa", "Muharraq", "Isa Town", "Sitra", "Jidhafs"],
  Bangladesh: [
    "Dhaka",
    "Chittagong",
    "Khulna",
    "Rajshahi",
    "Sylhet",
    "Barisal",
    "Rangpur",
  ],
  Barbade: ["Bridgetown", "Speightstown", "Oistins", "Holetown", "Bathsheba"],
  Biélorussie: [
    "Minsk",
    "Gomel",
    "Mogilev",
    "Vitebsk",
    "Grodno",
    "Brest",
    "Baranovichi",
  ],
  Belgique: [
    "Bruxelles",
    "Anvers",
    "Liège",
    "Charleroi",
    "Bruges",
    "Namur",
    "Leuven",
  ],
  Belize: [
    "Belmopan",
    "Belize City",
    "San Ignacio",
    "Corozal",
    "Dangriga",
    "Orange Walk",
  ],
  Bolivie: [
    "La Paz",
    "Santa Cruz",
    "Cochabamba",
    "Sucre",
    "Tarija",
    "Oruro",
    "Potosí",
  ],
  "Bosnie-Herzégovine": [
    "Sarajevo",
    "Banja Luka",
    "Mostar",
    "Zenica",
    "Tuzla",
    "Brčko",
    "Bihać",
  ],
  Botswana: [
    "Gaborone",
    "Francistown",
    "Molepolole",
    "Maun",
    "Serowe",
    "Kanye",
  ],
  Brésil: [
    "Brasília",
    "São Paulo",
    "Rio de Janeiro",
    "Salvador",
    "Fortaleza",
    "Belo Horizonte",
    "Curitiba",
  ],
  Brunéi: ["Bandar Seri Begawan", "Kuala Belait", "Seria", "Tutong"],
  Bulgarie: [
    "Sofia",
    "Plovdiv",
    "Varna",
    "Burgas",
    "Ruse",
    "Stara Zagora",
    "Pleven",
  ],
  Cambodge: [
    "Phnom Penh",
    "Siem Reap",
    "Battambang",
    "Sihanoukville",
    "Kampong Cham",
    "Prey Veng",
  ],
  Cameroun: [
    "Yaoundé",
    "Douala",
    "Bamenda",
    "Garoua",
    "Kumba",
    "Maroua",
    "Ngaoundéré",
  ],
  Canada: [
    "Ottawa",
    "Toronto",
    "Vancouver",
    "Montreal",
    "Calgary",
    "Edmonton",
    "Quebec City",
  ],
  "Îles Caïmans": ["George Town", "West Bay", "Bodden Town", "East End"],
  Chili: [
    "Santiago",
    "Valparaíso",
    "Concepción",
    "La Serena",
    "Antofagasta",
    "Temuco",
  ],
  Chine: [
    "Beijing",
    "Shanghai",
    "Hong Kong",
    "Chengdu",
    "Shenzhen",
    "Guangzhou",
    "Tianjin",
  ],
  Colombie: [
    "Bogotá",
    "Medellín",
    "Cali",
    "Barranquilla",
    "Cartagena",
    "Bucaramanga",
    "Pereira",
  ],
  Congo: ["Brazzaville", "Pointe-Noire", "Dolisie", "Nkayi", "Owando"],
  "Costa Rica": [
    "San José",
    "Alajuela",
    "Cartago",
    "Heredia",
    "Liberia",
    "Puntarenas",
  ],
  Croatie: ["Zagreb", "Split", "Rijeka", "Dubrovnik", "Osijek", "Zadar"],
  Cuba: [
    "Havana",
    "Santiago de Cuba",
    "Camagüey",
    "Holguín",
    "Santa Clara",
    "Cienfuegos",
  ],
  Chypre: ["Nicosie", "Limassol", "Larnaca", "Paphos", "Famagouste", "Kyrenia"],
  "République tchèque": [
    "Prague",
    "Brno",
    "Ostrava",
    "Plzeň",
    "Olomouc",
    "Liberec",
  ],
  Danemark: ["Copenhague", "Aarhus", "Odense", "Aalborg", "Esbjerg", "Randers"],
  "République dominicaine": [
    "Saint-Domingue",
    "Santiago de los Caballeros",
    "La Romana",
    "Punta Cana",
    "San Pedro de Macorís",
    "Puerto Plata",
  ],
  Équateur: ["Quito", "Guayaquil", "Cuenca", "Machala", "Manta", "Portoviejo"],
  Égypte: [
    "Le Caire",
    "Alexandrie",
    "Gizeh",
    "Sharm el-Sheikh",
    "Louxor",
    "Assouan",
  ],
  Salvador: [
    "San Salvador",
    "Santa Ana",
    "San Miguel",
    "Soyapango",
    "Santa Tecla",
  ],
  Estonie: ["Tallinn", "Tartu", "Narva", "Pärnu", "Kohtla-Järve", "Viljandi"],
  "Îles Féroé": ["Tórshavn", "Klaksvík", "Runavík"],
  Finlande: [
    "Helsinki",
    "Espoo",
    "Tampere",
    "Oulu",
    "Turku",
    "Vantaa",
    "Lahti",
  ],
  France: [
    "Paris",
    "Marseille",
    "Strasbourg",
    "Nantes",
    "Rennes",
    "Avignon",
    "Créteil",
    "Colmar",
    "Reims",
    "Toulon",
    "Antibes",
    "Bordeaux",
    "Toulouse",
    "Nice",
    "Grenoble",
    "Dijon",
    "Angers",
    "Carcassonne",
    "Caen",
    "Saint-Étienne",
    "Calais",
    "Ajaccio",
    "Lyon",
    "Lille",
    "Montpellier",
    "Le Havre",
    "Annecy",
    "Amiens",
    "Clermont-Ferrand",
    "Chambéry",
    "Cannes",
    "Rouen",
    "Aix-les-Bains",
  ],
  "Polynésie française": ["Papeete", "Faaa", "Punaauia"],
  Gabon: ["Libreville", "Port-Gentil", "Franceville", "Oyem", "Moanda"],
  Géorgie: ["Tbilissi", "Batoumi", "Zougdidi", "Koutaïssi", "Roustavi"],
  Allemagne: [
    "Berlin",
    "Munich",
    "Hambourg",
    "Francfort",
    "Cologne",
    "Stuttgart",
    "Düsseldorf",
  ],
  Ghana: ["Accra", "Kumasi", "Takoradi", "Tamale", "Cape Coast", "Tema"],
  Grèce: [
    "Athènes",
    "Thessalonique",
    "Patras",
    "Heraklion",
    "Larissa",
    "Volos",
  ],
  Groenland: ["Nuuk", "Sisimiut", "Ilulissat", "Qaqortoq", "Aasiaat"],
  Guadeloupe: [
    "Basse-Terre",
    "Pointe-à-Pitre",
    "Le Gosier",
    "Sainte-Anne",
    "Petit-Bourg",
  ],
  Guam: ["Hagåtña", "Dededo", "Tamuning"],
  Guatemala: [
    "Guatemala City",
    "Antigua Guatemala",
    "Quetzaltenango",
    "Escuintla",
    "Villa Nueva",
  ],
  Guinée: ["Conakry", "Nzérékoré", "Kindia", "Kankan", "Labé", "Boké"],
  Haïti: ["Port-au-Prince", "Cap-Haïtien", "Hinché", "Gonaïves", "Les Cayes"],
  "Royaume hachémite de Jordanie": [
    "Amman",
    "Zarqa",
    "Irbid",
    "Aqaba",
    "Madaba",
  ],
  Honduras: [
    "Tegucigalpa",
    "San Pedro Sula",
    "La Ceiba",
    "Choloma",
    "El Progreso",
  ],
  "Hong Kong": ["Hong Kong", "Kowloon", "New Territories"],
  Hongrie: ["Budapest", "Debrecen", "Szeged", "Miskolc", "Pécs"],
  Islande: ["Reykjavik", "Akureyri", "Kópavogur", "Hafnarfjörður"],
  Inde: [
    "New Delhi",
    "Mumbai",
    "Bangalore",
    "Hyderabad",
    "Chennai",
    "Kolkata",
    "Ahmedabad",
  ],
  Indonésie: [
    "Jakarta",
    "Surabaya",
    "Medan",
    "Bandung",
    "Semarang",
    "Makassar",
  ],
  Iran: ["Téhéran", "Machhad", "Ispahan", "Chiraz", "Tabriz"],
  Irak: ["Bagdad", "Bassorah", "Erbil", "Mosoul", "Najaf", "Karbala"],
  Irlande: ["Dublin", "Cork", "Limerick", "Galway", "Waterford"],
  "Île de Man": ["Douglas", "Ramsey", "Peel"],
  Israël: ["Tel Aviv", "Jérusalem", "Haïfa", "Rishon LeZion", "Petah Tikva"],
  Italie: ["Rome", "Milan", "Naples", "Turin", "Palerme", "Gênes"],
  Jamaïque: ["Kingston", "Montego Bay", "Mandeville", "Ocho Rios", "Portmore"],
  Japon: ["Tokyo", "Osaka", "Kyoto", "Yokohama", "Nagoya", "Sapporo"],
  Kazakhstan: [
    "Almaty",
    "Astana",
    "Shymkent",
    "Karaganda",
    "Aktobe",
    "Pavlodar",
  ],
  Kenya: ["Nairobi", "Mombasa", "Kisumu", "Nakuru", "Eldoret", "Thika"],
  Kosovo: ["Pristina", "Prizren", "Gjilan", "Peja"],
  Koweït: ["Koweït City", "Al Ahmadi", "Hawalli"],
  Lettonie: ["Riga", "Daugavpils", "Liepāja"],
  Liban: [
    "Beirut",
    "Sidon",
    "Nabatieh",
    "Aley",
    "Ras El Matn",
    "Jdeideh",
    "Kfarshima",
    "Ghaziyeh",
    "Batroun",
    "Qarnayel",
    "Tripoli",
    "Zahlé",
    "Baalbek",
    "Aakkar",
    "Baabda",
    "Habbouch",
    "Halba",
    "Naqoura",
    "Chouf",
    "Qaaqour",
    "Tyre",
    "Jounieh",
    "Byblos",
    "Hammana",
    "Bteghrine",
    "Zgharta",
    "Jbeil",
    "Khenchara",
    "Bourj Hammoud",
    "Cornet Chahwan",
    "Hazmieh",
    "Beit Chabeb",
    "Saida",
    "Srifa",
    "Zikrit",
    "Qob Elias",
    "Ghobairy",
    "Aintoura",
    "Jal El Dib",
    "Minieh - Danniyeh",
    "Qana",
    "Damour",
    "Kahaleh",
    "Antelias",
    "Mansourieh",
    "Zalqa",
    "Sarafand",
    "Qalamoun",
    "Kfar Aabida",
  ],
  Libye: ["Tripoli", "Benghazi", "Misrata", "Zawiya"],
  Liechtenstein: ["Vaduz", "Schaan", "Triesen"],
  Luxembourg: ["Luxembourg City", "Esch-sur-Alzette", "Differdange"],
  Macédoine: ["Skopje", "Bitola", "Kumanovo"],
  Madagascar: [
    "Antananarivo",
    "Toamasina",
    "Antsirabe",
    "Fianarantsoa",
    "Mahajanga",
  ],
  Malaisie: ["Kuala Lumpur", "George Town", "Johor Bahru", "Ipoh", "Kuching"],
  Malte: ["La Valette", "Birkirkara", "Mosta"],
  Martinique: ["Fort-de-France", "Le Lamentin", "Schoelcher"],
  Maurice: ["Port-Louis", "Beau Bassin-Rose Hill", "Vacoas-Phoenix"],
  Mayotte: ["Mamoudzou", "Dzaoudzi", "Koungou"],
  Mexique: ["Mexico City", "Guadalajara", "Monterrey", "Puebla", "Tijuana"],
  Mongolie: ["Oulan-Bator", "Erdenet", "Darkhan", "Choibalsan", "Khovd"],
  Monténégro: ["Podgorica", "Nikšić", "Bijelo Polje", "Bar", "Herceg Novi"],
  Maroc: ["Rabat", "Casablanca", "Marrakech", "Fès", "Tanger"],
  Mozambique: ["Maputo", "Beira", "Nampula", "Matola"],
  "Myanmar [Birmanie]": [
    "Naypyidaw",
    "Yangon",
    "Mandalay",
    "Mawlamyine",
    "Bago",
  ],
  Namibie: ["Windhoek", "Walvis Bay", "Swakopmund"],
  Népal: ["Kathmandu", "Pokhara", "Lalitpur", "Biratnagar", "Bharatpur"],
  "Pays-Bas": ["Amsterdam", "Rotterdam", "La Haye", "Utrecht", "Eindhoven"],
  "Nouvelle-Calédonie": ["Nouméa", "Mont-Dore", "Dumbéa"],
  "Nouvelle-Zélande": [
    "Auckland",
    "Wellington",
    "Christchurch",
    "Hamilton",
    "Tauranga",
  ],
  Nicaragua: ["Managua", "León", "Granada", "Masaya"],
  Nigéria: ["Lagos", "Abuja", "Kano", "Ibadan", "Port Harcourt", "Kaduna"],
  Norvège: [
    "Oslo",
    "Bergen",
    "Stavanger",
    "Trondheim",
    "Drammen",
    "Fredrikstad",
  ],
  Oman: ["Mascate", "Salalah", "Sohar"],
  Pakistan: ["Islamabad", "Karachi", "Lahore", "Peshawar", "Quetta", "Multan"],
  Palestine: ["Ramallah", "Gaza", "Bethléem", "Hébron", "Naplouse"],
  Panama: ["Panama City", "San Miguelito", "David"],
  "Papouasie-Nouvelle-Guinée": ["Port Moresby", "Lae", "Madang"],
  Paraguay: ["Asunción", "Ciudad del Este", "San Lorenzo"],
  Pérou: ["Lima", "Arequipa", "Cusco", "Trujillo", "Chiclayo"],
  Philippines: ["Manille", "Cebu", "Davao", "Zamboanga", "Cagayan de Oro"],
  Pologne: ["Varsovie", "Cracovie", "Wrocław", "Poznań", "Gdańsk", "Szczecin"],
  Portugal: ["Lisbonne", "Porto", "Braga", "Coimbra", "Faro", "Setúbal"],
  "Porto Rico": ["San Juan", "Bayamón", "Ponce"],
  "République de Corée": ["Séoul", "Busan", "Incheon", "Daegu"],
  "République de Lituanie": ["Vilnius", "Kaunas", "Klaipėda"],
  "République de Moldavie": ["Chișinău", "Tiraspol", "Bălți"],
  Roumanie: [
    "Bucarest",
    "Cluj-Napoca",
    "Timișoara",
    "Iași",
    "Constanța",
    "Craiova",
  ],
  Russie: [
    "Moscou",
    "Saint-Pétersbourg",
    "Novossibirsk",
    "Ekaterinbourg",
    "Kazan",
    "Vladivostok",
  ],
  "Sainte-Lucie": ["Castries", "Vieux Fort", "Soufrière"],
  "Saint-Marin": ["Saint-Marino", "Borgo Maggiore", "Serravalle"],
  "Arabie Saoudite": ["Riyad", "Jeddah", "La Mecque", "Médine", "Dammam"],
  Sénégal: ["Dakar", "Saint-Louis", "Thiès", "Ziguinchor", "Kaolack"],
  Serbie: ["Belgrade", "Novi Sad", "Niš", "Kragujevac", "Subotica"],
  Singapour: ["Singapour"],
  Slovaquie: ["Bratislava", "Košice", "Prešov", "Žilina", "Banská Bystrica"],
  Slovénie: ["Ljubljana", "Maribor", "Celje", "Koper", "Kranj"],
  "Afrique du Sud": [
    "Johannesburg",
    "Le Cap",
    "Durban",
    "Pretoria",
    "Port Elizabeth",
  ],
  Espagne: ["Madrid", "Barcelone", "Valence", "Séville", "Bilbao"],
  "Sri Lanka": ["Colombo", "Kandy", "Galle", "Jaffna", "Negombo"],
  Soudan: ["Khartoum", "Omdurman", "Port-Soudan", "Nyala", "Kassala"],
  Suriname: ["Paramaribo", "Lelydorp", "Nieuw Nickerie", "Moengo", "Albina"],
  Swaziland: ["Mbabane", "Manzini", "Big Bend", "Malkerns", "Nhlangano"],
  Suède: ["Stockholm", "Gothenburg", "Malmö", "Uppsala", "Västerås"],
  Suisse: ["Zurich", "Genève", "Bâle", "Lausanne", "Berne"],
  Taïwan: ["Taipei", "Kaohsiung", "Taichung", "Tainan", "Hsinchu"],
  Tanzanie: ["Dodoma", "Dar es Salaam", "Mwanza", "Arusha", "Zanzibar"],
  Thaïlande: ["Bangkok", "Chiang Mai", "Phuket", "Pattaya", "Khon Kaen"],
  "Trinité-et-Tobago": [
    "Port of Spain",
    "San Fernando",
    "Chaguanas",
    "Arima",
    "Couva",
  ],
  Tunisie: ["Tunis", "Sfax", "Sousse", "Kairouan", "Bizerte"],
  Turquie: ["Istanbul", "Ankara", "Izmir", "Bursa", "Antalya"],
  "Îles Vierges des États-Unis": [
    "Charlotte Amalie",
    "Cruz Bay",
    "Christiansted",
    "Frederiksted",
  ],
  Ukraine: ["Kiev", "Odessa", "Kharkiv", "Dnipro", "Lviv"],
  "Émirats Arabes Unis": [
    "Abou Dabi",
    "Dubaï",
    "Sharjah",
    "Ajman",
    "Ras Al Khaimah",
  ],
  "Royaume-Uni": [
    "Londres",
    "Édimbourg",
    "Manchester",
    "Birmingham",
    "Glasgow",
  ],
  "États-Unis": ["New York", "Los Angeles", "Chicago", "Houston", "Miami"],
  Uruguay: ["Montevideo", "Salto", "Paysandú", "Maldonado", "Rivera"],
  Venezuela: ["Caracas", "Maracaibo", "Valencia", "Barquisimeto", "Maracay"],
  Vietnam: ["Hanoï", "Ho Chi Minh-Ville", "Da Nang", "Haïphong", "Cần Thơ"],
  Zambie: ["Lusaka", "Kitwe", "Ndola", "Kabwe", "Chingola"],
  Zimbabwe: ["Harare", "Bulawayo", "Chitungwiza", "Mutare", "Gweru"],
};

export const COUNTRIES_PAIR = {
  Afghanistan: "Afghanistan",
  Albanie: "Albanie",
  Algérie: "Algérie",
  Angola: "Angola",
  Argentine: "Argentine",
  Arménie: "Arménie",
  Aruba: "Aruba",
  Australie: "Australie",
  Autriche: "Autriche",
  Azerbaïdjan: "Azerbaïdjan",
  Bahamas: "Bahamas",
  Bahreïn: "Bahreïn",
  Bangladesh: "Bangladesh",
  Barbade: "Barbade",
  Biélorussie: "Biélorussie",
  Belgique: "Belgique",
  Belize: "Belize",
  Bolivie: "Bolivie",
  "Bosnie-Herzégovine": "Bosnie-Herzégovine",
  Botswana: "Botswana",
  Brésil: "Brésil",
  Brunéi: "Brunéi",
  Bulgarie: "Bulgarie",
  Cambodge: "Cambodge",
  Cameroun: "Cameroun",
  Canada: "Canada",
  "Îles Caïmans": "Îles Caïmans",
  Chili: "Chili",
  Chine: "Chine",
  Colombie: "Colombie",
  Congo: "Congo",
  "Costa Rica": "Costa Rica",
  Croatie: "Croatie",
  Cuba: "Cuba",
  Chypre: "Chypre",
  "République tchèque": "République tchèque",
  Danemark: "Danemark",
  "République dominicaine": "République dominicaine",
  Équateur: "Équateur",
  Égypte: "Égypte",
  Salvador: "Salvador",
  Estonie: "Estonie",
  "Îles Féroé": "Îles Féroé",
  Finlande: "Finlande",
  France: "France",
  "Polynésie française": "Polynésie française",
  Gabon: "Gabon",
  Géorgie: "Géorgie",
  Allemagne: "Allemagne",
  Ghana: "Ghana",
  Grèce: "Grèce",
  Groenland: "Groenland",
  Guadeloupe: "Guadeloupe",
  Guam: "Guam",
  Guatemala: "Guatemala",
  Guinée: "Guinée",
  Haïti: "Haïti",
  "Royaume hachémite de Jordanie": "Royaume hachémite de Jordanie",
  Honduras: "Honduras",
  "Hong Kong": "Hong Kong",
  Hongrie: "Hongrie",
  Islande: "Islande",
  Inde: "Inde",
  Indonésie: "Indonésie",
  Iran: "Iran",
  Irak: "Irak",
  Irlande: "Irlande",
  "Île de Man": "Île de Man",
  Israël: "Israël",
  Italie: "Italie",
  Jamaïque: "Jamaïque",
  Japon: "Japon",
  Kazakhstan: "Kazakhstan",
  Kenya: "Kenya",
  Kosovo: "Kosovo",
  Koweït: "Koweït",
  Lettonie: "Lettonie",
  Liban: "Liban",
  Libye: "Libye",
  Liechtenstein: "Liechtenstein",
  Luxembourg: "Luxembourg",
  Macédoine: "Macédoine",
  Madagascar: "Madagascar",
  Malaisie: "Malaisie",
  Malte: "Malte",
  Martinique: "Martinique",
  Maurice: "Maurice",
  Mayotte: "Mayotte",
  Mexique: "Mexique",
  Mongolie: "Mongolie",
  Monténégro: "Monténégro",
  Maroc: "Maroc",
  Mozambique: "Mozambique",
  "Myanmar [Birmanie]": "Myanmar [Birmanie]",
  Namibie: "Namibie",
  Népal: "Népal",
  "Pays-Bas": "Pays-Bas",
  "Nouvelle-Calédonie": "Nouvelle-Calédonie",
  "Nouvelle-Zélande": "Nouvelle-Zélande",
  Nicaragua: "Nicaragua",
  Nigéria: "Nigéria",
  Norvège: "Norvège",
  Oman: "Oman",
  Pakistan: "Pakistan",
  Palestine: "Palestine",
  Panama: "Panama",
  "Papouasie-Nouvelle-Guinée": "Papouasie-Nouvelle-Guinée",
  Paraguay: "Paraguay",
  Pérou: "Pérou",
  Philippines: "Philippines",
  Pologne: "Pologne",
  Portugal: "Portugal",
  "Porto Rico": "Porto Rico",
  "République de Corée": "République de Corée",
  "République de Lituanie": "République de Lituanie",
  "République de Moldavie": "République de Moldavie",
  Roumanie: "Roumanie",
  Russie: "Russie",
  "Sainte-Lucie": "Sainte-Lucie",
  "Saint-Marin": "Saint-Marin",
  "Arabie Saoudite": "Arabie Saoudite",
  Sénégal: "Sénégal",
  Serbie: "Serbie",
  Singapour: "Singapour",
  Slovaquie: "Slovaquie",
  Slovénie: "Slovénie",
  "Afrique du Sud": "Afrique du Sud",
  Espagne: "Espagne",
  "Sri Lanka": "Sri Lanka",
  Soudan: "Soudan",
  Suriname: "Suriname",
  Swaziland: "Swaziland",
  Suède: "Suède",
  Suisse: "Suisse",
  Taïwan: "Taïwan",
  Tanzanie: "Tanzanie",
  Thaïlande: "Thaïlande",
  "Trinité-et-Tobago": "Trinité-et-Tobago",
  Tunisie: "Tunisie",
  Turquie: "Turquie",
  "Îles Vierges des États-Unis": "Îles Vierges des États-Unis",
  Ukraine: "Ukraine",
  "Émirats Arabes Unis": "Émirats Arabes Unis",
  "Royaume-Uni": "Royaume-Uni",
  "États-Unis": "États-Unis",
  Uruguay: "Uruguay",
  Venezuela: "Venezuela",
  Vietnam: "Vietnam",
  Zambie: "Zambie",
  Zimbabwe: "Zimbabwe",
} as const;

export function mapCountryNames(inputName: string) {
  const mapping = {
    Afghanistan: "Afghanistan",
    Albania: "Albanie",
    Algeria: "Algérie",
    Angola: "Angola",
    Argentina: "Argentine",
    Armenia: "Arménie",
    Australia: "Australie",
    Austria: "Autriche",
    Azerbaijan: "Azerbaïdjan",
    Bahamas: "Bahamas",
    Bangladesh: "Bangladesh",
    Belarus: "Biélorussie",
    Belgium: "Belgique",
    Belize: "Belize",
    Bolivia: "Bolivie",
    "Bosnia and Herz.": "Bosnie-Herzégovine",
    Botswana: "Botswana",
    Brazil: "Brésil",
    Brunei: "Brunéi",
    Bulgaria: "Bulgarie",
    "Burkina Faso": "Burkina Faso",
    Burundi: "Burundi",
    Cambodia: "Cambodge",
    Cameroon: "Cameroun",
    Canada: "Canada",
    "Central African Rep.": "République centrafricaine",
    Chad: "Tchad",
    Chile: "Chili",
    China: "Chine",
    Colombia: "Colombie",
    Congo: "Congo",
    "Costa Rica": "Costa Rica",
    Croatia: "Croatie",
    Cuba: "Cuba",
    Cyprus: "Chypre",
    Czechia: "République tchèque",
    "Côte d'Ivoire": "Côte d'Ivoire",
    "Dem. Rep. Congo": "République démocratique du Congo",
    Denmark: "Danemark",
    Djibouti: "Djibouti",
    "Dominican Rep.": "République dominicaine",
    Ecuador: "Équateur",
    Egypt: "Égypte",
    "El Salvador": "Salvador",
    "Eq. Guinea": "Guinée équatoriale",
    Eritrea: "Érythrée",
    Estonia: "Estonie",
    Ethiopia: "Éthiopie",
    "Falkland Is.": "Îles Falkland",
    Fiji: "Fidji",
    Finland: "Finlande",
    "Fr. S. Antarctic Lands": "Terres australes et antarctiques françaises",
    France: "France",
    Gabon: "Gabon",
    Gambia: "Gambie",
    Georgia: "Géorgie",
    Germany: "Allemagne",
    Ghana: "Ghana",
    Greece: "Grèce",
    Greenland: "Groenland",
    Guatemala: "Guatemala",
    Guinea: "Guinée",
    "Guinea-Bissau": "Guinée-Bissau",
    Guyana: "Guyana",
    Haiti: "Haïti",
    Honduras: "Honduras",
    Hungary: "Hongrie",
    Iceland: "Islande",
    India: "Inde",
    Indonesia: "Indonésie",
    Iran: "Iran",
    Iraq: "Irak",
    Ireland: "Irlande",
    Israel: "Israël",
    Italy: "Italie",
    Jamaica: "Jamaïque",
    Japan: "Japon",
    Jordan: "Jordanie",
    Kazakhstan: "Kazakhstan",
    Kenya: "Kenya",
    Kosovo: "Kosovo",
    Kuwait: "Koweït",
    Kyrgyzstan: "Kirghizistan",
    Laos: "Laos",
    Latvia: "Lettonie",
    Lebanon: "Liban",
    Lesotho: "Lesotho",
    Liberia: "Libéria",
    Libya: "Libye",
    Lithuania: "Lituanie",
    Luxembourg: "Luxembourg",
    Macedonia: "Macédoine",
    Madagascar: "Madagascar",
    Malawi: "Malawi",
    Malaysia: "Malaisie",
    Mali: "Mali",
    Mauritania: "Mauritanie",
    Mexico: "Mexique",
    Moldova: "Moldavie",
    Mongolia: "Mongolie",
    Montenegro: "Monténégro",
    Morocco: "Maroc",
    Mozambique: "Mozambique",
    Myanmar: "Myanmar [Birmanie]",
    Namibia: "Namibie",
    Nepal: "Népal",
    Netherlands: "Pays-Bas",
    "New Caledonia": "Nouvelle-Calédonie",
    "New Zealand": "Nouvelle-Zélande",
    Nicaragua: "Nicaragua",
    Niger: "Niger",
    Nigeria: "Nigéria",
    "North Korea": "Corée du Nord",
    Norway: "Norvège",
    Oman: "Oman",
    Pakistan: "Pakistan",
    Palestine: "Palestine",
    Panama: "Panama",
    "Papua New Guinea": "Papouasie-Nouvelle-Guinée",
    Paraguay: "Paraguay",
    Peru: "Pérou",
    Philippines: "Philippines",
    Poland: "Pologne",
    Portugal: "Portugal",
    "Puerto Rico": "Porto Rico",
    Qatar: "Qatar",
    Romania: "Roumanie",
    Russia: "Russie",
    Rwanda: "Rwanda",
    "S. Sudan": "Soudan du Sud",
    "Saudi Arabia": "Arabie Saoudite",
    Senegal: "Sénégal",
    Serbia: "Serbie",
    "Sierra Leone": "Sierra Leone",
    Slovakia: "Slovaquie",
    Slovenia: "Slovénie",
    "Solomon Is.": "Îles Salomon",
    Somalia: "Somalie",
    "South Africa": "Afrique du Sud",
    "South Korea": "Corée du Sud",
    Spain: "Espagne",
    "Sri Lanka": "Sri Lanka",
    Sudan: "Soudan",
    Suriname: "Suriname",
    Sweden: "Suède",
    Switzerland: "Suisse",
    Syria: "Syrie",
    Taiwan: "Taïwan",
    Tajikistan: "Tadjikistan",
    Tanzania: "Tanzanie",
    Thailand: "Thaïlande",
    "Timor-Leste": "Timor oriental",
    Togo: "Togo",
    "Trinidad and Tobago": "Trinité-et-Tobago",
    Tunisia: "Tunisie",
    Turkey: "Turquie",
    Turkmenistan: "Turkménistan",
    Uganda: "Ouganda",
    Ukraine: "Ukraine",
    "United Arab Emirates": "Émirats Arabes Unis",
    "United Kingdom": "Royaume-Uni",
    "United States of America": "États-Unis",
    Uruguay: "Uruguay",
    Uzbekistan: "Ouzbékistan",
    Vanuatu: "Vanuatu",
    Venezuela: "Venezuela",
    Vietnam: "Vietnam",
    "W. Sahara": "Sahara occidental",
    Yemen: "Yémen",
    Zambia: "Zambie",
    Zimbabwe: "Zimbabwe",
    eSwatini: "Swaziland",
  };
  // @ts-expect-error - TS doesn't know the key exists
  return mapping[inputName];
}
